<template>
  <div class="p_doc_box">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>知识库</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/manageSys' }">管理制度</el-breadcrumb-item>
                <el-breadcrumb-item>杰博数字化系统管理制度</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_doc_content">
            <p class="doc_txt">杰博数字化系统管理制度</p>
            <!-- <div class="doc_btn">
                <el-button type="success" size="small" @click="onDownloadFile">下载</el-button>
            </div> -->
            <div class="p_pdf_box">
                <pdf v-for="i in numPages"
                :key="i"
	            :src="pdfSrc"
	            :page="i" style="width:100%" ref="pdf"></pdf>
            </div>
            <!-- <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="使用指南"></el-tab-pane>
            </el-tabs> -->
        </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf' //引入下载的vue-pdf
import { download } from '@/utils' //封装的下载方法
var comPath = location.origin + '/cloudimg/helpfile/%E6%9D%B0%E5%8D%9A%E6%95%B0%E5%AD%97%E5%8C%96%E7%B3%BB%E7%BB%9F%E7%AE%A1%E7%90%86%E5%88%B6%E5%BA%A61.0_2.pdf'
var loadingTask = pdf.createLoadingTask(comPath);
export default {
    components: {
        pdf
    },
  data() {
    return {
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        fileType: 'pdf', // 文件类型
        pdfSrc:loadingTask,
        numPages: undefined
    }
  },
  created() {
    // this.pdfSrc = 'https://emp.jobkeji.cn/cloudimg/helpfile/%E6%9D%B0%E5%8D%9A%E6%95%B0%E5%AD%97%E5%8C%96%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
    // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
    // this.pdfSrc = pdf.createLoadingTask(this.pdfSrc)
  },
  mounted() {
    this.pdfSrc.promise.then(pdf => {
        this.numPages = pdf.numPages
    })
  },
  methods: {
    // pdf加载时
    loadPdfHandler (e) {
    this.currentPage = 1 // 加载的时候先加载第一页
    },
    getpdfpage() {
      let loadingTask = pdf.createLoadingTask(this.pdfSrc)
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages
        })
        .catch((err) => {
          console.error("失败", err)
        });
    },
    //下载pdf
    onDownloadFile() {
        download(this.pdfSrc)
    }
  }
};
</script>

<style>
.p_doc_content{
    padding: 20px;
    background-color: #fff;
}
</style>
<style scoped>
.p_doc_content .doc_txt{
    padding: 0 0 10px;
    text-align: center;
    font-size: 16px;
    color:#333;
    border-bottom: 1px dashed #ddd;
}
.doc_btn{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
.p_doc_content{
    min-height: 800px;
    padding: 20px;
    background-color: #fff;
}
.el-pagination{
  background-color: #fff;
}
</style>